// import loggingService from './loggingService'

//var serviceName = 'utilService'
const timeOutCheck = 30000

function isAppIdle () {
    var lastActiveTime = new Date(localStorage.getItem('shpoAppActive')) || new Date()
    return (new Date() - lastActiveTime >= timeOutCheck)
}

export default {
    isAppIdle: isAppIdle
}



// WEBPACK FOOTER //
// ./src/services/util/utilService.js